import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const BlogCard = ({ title, img, subtitle, author, slug }) => {
    const navigate = useNavigate();

    return (
        <>
            <div className="col-md-6 mb-4" onClick={() => navigate(slug)} style={{ cursor: "pointer" }}>
                <div className="featured-blog">
                    <img src={`${process.env.REACT_APP_WEB_URL}${img}`} alt="Featured Blog" />
                    <div className="featured-overlay">
                        <div className="blog-left-content">
                            <h2>{title}</h2>
                            <p>{subtitle}</p>
                            <span>By {author}</span>
                        </div>
                        <div className="d-flex align-items-end justify-content-center">
                            <Link to={slug} className="btn">CLICK HERE</Link>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default BlogCard;
